import axios from '~/utils/axiosInstance';

export interface StartCimGenerationResponse {
  apiEvent: { id: string };
}

export interface CimGenerationPollResponse {
  status: 'PENDING' | 'SUCCESS' | 'ERROR';
  statusMessage?: string;
  result?: {
    slidesUrl?: string;
    slidesId?: string;
    portfolioId?: string;
    statusMessage?: string;
    message?: string;
    details?: string;
    step?: string;
  };
}

export async function startCimGeneration(
  portfolioId: string,
  idempotencyKey?: string
): Promise<StartCimGenerationResponse> {
  const response = await axios.post(
    `/admin/portfolios/${portfolioId}/generate-cim`,
    idempotencyKey ? { idempotencyKey } : {}
  );
  return response.data;
}

export async function startCimGenerationForProject(
  projectId: string,
  idempotencyKey?: string
): Promise<StartCimGenerationResponse> {
  const response = await axios.post(
    `/admin/projects/${projectId}/generate-cim`,
    idempotencyKey ? { idempotencyKey } : {}
  );
  return response.data;
}

export async function pollCimGeneration(
  apiEventId: string
): Promise<CimGenerationPollResponse> {
  const response = await axios.get(
    `/admin/cim-generation/async-request/${apiEventId}/poll`
  );
  return response.data;
}
